/**
 * When a block/section is visible to users, optional `visible_ticket_ids` limits it to
 * holders of those tiers. Empty / missing list = all purchased tickets (legacy behaviour).
 */
export function shouldShowForPurchasedTicketTier(args: {
  editMode: boolean
  visible: boolean
  visibleTicketIds?: number[] | null
  /** From API on preview; undefined = do not apply tier filter (editor / org). */
  viewerEventTicketId?: number | null
}): boolean {
  if (args.editMode) {
    return true
  }
  if (!args.visible) {
    return false
  }
  const ids = (args.visibleTicketIds ?? []).filter(
    (id) => Number.isFinite(id) && id > 0,
  )
  if (ids.length === 0) {
    return true
  }
  if (args.viewerEventTicketId === undefined) {
    return true
  }
  if (args.viewerEventTicketId === null) {
    return false
  }
  return ids.includes(args.viewerEventTicketId)
}
